module.exports = __webpack_public_path__ + "img/harvard-logo.fe4f52de.png";